module.exports = __webpack_public_path__ + "static/img/permit.bb306d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/permit.svg
// module id = AJDJ
// module chunks = 1